<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()"
      ><img src="assets/images/logo.svg" alt="TVSHelper Logo"
    /></a>
  </div>
</div>

<div class="header-container">
  <div class="notification-wrapper" [nbPopover]="notificationList" nbPopoverPlacement="bottom" nbPopoverTrigger="click">
    <nb-icon icon="bell-outline" size="large"></nb-icon>
    <nb-badge [text]="notifications.length > 9 ? '9+' : notifications.length"
      [status]="notifications.length > 0 ? 'danger' : 'success'" position="top right">
    </nb-badge>
  </div>

  <ng-template #notificationList>
    <nb-card size="medium" class="notification-list-card">
      <nb-card-body class="pb-0">
        <div *ngIf="notifications.length; else noNotifications">
          <div *ngFor="let notification of notifications; let i = index" class="notification-item"
            [ngStyle]="{borderBottom: notifications.length - 1 === i ? '0' : '1px solid #eee'}" (click)="markAsRead(notification.id)" title="Click to mark as read">
            <div class="notification-header">
              <strong>{{ notification.title }}</strong>
              <small>{{ notification.createdAt | date:'short' }}</small>
            </div>
            <div class="notification-content">
              {{ notification.content }}
            </div>
          </div>
        </div>
        <ng-template #noNotifications>
          <p class="text-center text-muted">No notifications</p>
        </ng-template>
      </nb-card-body>
    </nb-card>
  </ng-template>

  <nb-actions size="small">
    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
      <nb-user [nbContextMenu]="userMenu" nbContextMenuTag="user-menu" [onlyPicture]="userPictureOnly"
        [name]="user?.firstName" [picture]="user?.avatar?.path || 'assets/images/user.png'">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>
